import Vue from 'vue';
import Vuex from 'vuex';
import mmlconfig from './modules/mmlconfig';
import trackConfig from './modules/trackConfig';
import topoConfig from './modules/topoConfig';
import observeConfig from './modules/observeConfig';
Vue.use(Vuex);

const state = {

};

const mutations = {

};

const actions = {

};
export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    mmlconfig,
    trackConfig,
    topoConfig,
    observeConfig,
  }
});
